import React, { createContext, useContext, useMemo, useState } from "react";

const TicketsContext = createContext(null);

const mockTickets = [
  { id: "t-001", date: "2026-02-02", type: "Bug", assignee: "Mehmet Yılmaz", label: "Backend", status: "Closed" },
  { id: "t-002", date: "2026-02-05", type: "Task", assignee: "Merve Kara", label: "Frontend", status: "Open" },
  { id: "t-003", date: "2026-02-05", type: "Bug", assignee: "Merve Kara", label: "Frontend", status: "Closed" },
  { id: "t-004", date: "2026-02-18", type: "Improvement", assignee: "Oğuz Demir", label: "API", status: "Closed" },
];

const parseDate = (val) => {
  const d = new Date(val);
  return isNaN(d.getTime()) ? null : d;
};

export default function TicketsProvider({ children }) {
  const [tickets] = useState(mockTickets);
  const [type, setType] = useState("");
  const [assignee, setAssignee] = useState("");
  const [label, setLabel] = useState("");
  const [viewMonth, setViewMonth] = useState(new Date("2026-02-01"));

  const types = useMemo(() => Array.from(new Set(tickets.map((t) => t.type))), [tickets]);
  const assignees = useMemo(() => Array.from(new Set(tickets.map((t) => t.assignee))), [tickets]);
  const labels = useMemo(() => Array.from(new Set(tickets.map((t) => t.label))), [tickets]);

  const chartData = useMemo(() => {
    const year = viewMonth.getFullYear();
    const month = viewMonth.getMonth();
    const days = new Date(year, month + 1, 0).getDate();
    const arr = Array.from({ length: days }, (_, i) => ({ day: i + 1, open: 0, closed: 0 }));

    tickets.forEach((t) => {
      const dt = parseDate(t.date);
      if (!dt || dt.getFullYear() !== year || dt.getMonth() !== month) return;
      if (type && t.type !== type) return;
      if (assignee && t.assignee !== assignee) return;
      if (label && t.label !== label) return;
      const idx = dt.getDate() - 1;
      if (t.status === "Closed") arr[idx].closed += 1;
      else arr[idx].open += 1;
    });
    return arr;
  }, [tickets, type, assignee, label, viewMonth]);

  const value = useMemo(
    () => ({
      type,
      setType,
      assignee,
      setAssignee,
      label,
      setLabel,
      viewMonth,
      setViewMonth,
      types,
      assignees,
      labels,
      chartData,
    }),
    [type, assignee, label, viewMonth, types, assignees, labels, chartData]
  );

  return <TicketsContext.Provider value={value}>{children}</TicketsContext.Provider>;
};

export const useTickets = () => {
  const ctx = useContext(TicketsContext);
  if (!ctx) throw new Error("useTickets must be used within TicketsProvider");
  return ctx;
};

export const useTicketsOptional = () => useContext(TicketsContext);
